import JustValidate from 'just-validate'

const groups = document.querySelectorAll('.group')
const accountRoot = document.querySelector('.account')
const personalInfoForm = document.getElementById('personal-info')
const accountDetailsForm = document.getElementById('account-details')

if (accountRoot) {
	groups.forEach(group => {
		const staticBlock = group.querySelector('.static')
		const editBlock = group.querySelector('.edit')
		const toggleBtn = group.querySelector('.toggleMode')
		const toggleBtnCancel = toggleBtn.getAttribute('data-cancel')
		const toggleBtnEdit = toggleBtn.getAttribute('data-edit')

		toggleBtn.addEventListener('click', () => {
			if (staticBlock.style.display === 'block') {
				staticBlock.style.display = 'none'
				editBlock.style.display = 'block'
				toggleBtn.textContent = toggleBtnCancel
			} else {
				staticBlock.style.display = 'block'
				editBlock.style.display = 'none'
				toggleBtn.textContent = toggleBtnEdit
			}
		})
	})
}

if (personalInfoForm) {
	const validator = new JustValidate('#personal-info')

	validator.addField('#name', [{ rule: 'required' }]).addField('#phone', [{ rule: 'required' }])

	personalInfoForm.addEventListener('submit', function (event) {
		event.preventDefault()

		validator.validate()

		if (validator.isValid) {
			let formData = new FormData(personalInfoForm)
			for (let pair of formData.entries()) {
				console.log(pair[1])
			}
		}
	})
}

if (accountDetailsForm) {
	const validator = new JustValidate('#account-details')

	validator.addField('#email', [{ rule: 'required' }, { rule: 'email' }])
	validator.addField('#password', [{ rule: 'required' }])
	validator.addField('#password-new', [{ rule: 'required' }])
	validator.addField('#password-repeat', [{ rule: 'required' }])

	accountDetailsForm.addEventListener('submit', function (event) {
		event.preventDefault()

		validator.validate()

		if (validator.isValid) {
			let formData = new FormData(accountDetailsForm)
			for (let pair of formData.entries()) {
				console.log(pair[1])
			}
		}
	})
}
